import React, { useState, useEffect } from 'react';
import GlobalError from '../components/GlobalError';
import useDataSelect from '../hooks/useDataSelect';
import DefinitionRow from '../components/DefinitionRow';
import { Typography, Paper } from '@mui/material';
const CompanyPage = () => {
    // データセット
    const { dataset: settingData, loading, error, refetch } = useDataSelect('/setting/company');
    if (error) return <GlobalError errorMessage={error} />;
    return (
        <>
            <Typography component='h1' variant="h1">特定商取引法に基づく表記</Typography>

            <Paper variant='section'>
                <DefinitionRow label="販売事業者名">
                    <Typography >{settingData.company_name}</Typography>
                </DefinitionRow>

                <DefinitionRow label="住所">
                    <Typography>〒{settingData.postal_code}
                        {'\n'}
                        {settingData.state}{settingData.address_line}</Typography>
                </DefinitionRow>

                <DefinitionRow label="運営責任者">
                    <Typography>{settingData.representative}</Typography>
                </DefinitionRow>

                <DefinitionRow label="商品代金以外の必要料金">
                    <Typography>{settingData.additional_fees}</Typography>
                </DefinitionRow>

                <DefinitionRow label="不良品対応">
                    <Typography>{settingData.defective_product_policy}</Typography>
                </DefinitionRow>

                <DefinitionRow label="返品送料">
                    <Typography>{settingData.return_shipping_policy}</Typography>
                </DefinitionRow>

                <DefinitionRow label="返品・キャンセルについて">
                    <Typography>{settingData.return_cancel_policy}</Typography>
                </DefinitionRow>

                <DefinitionRow label="商品引き渡し時期">
                    <Typography>{settingData.delivery_time}</Typography>
                </DefinitionRow>

                <DefinitionRow label="支払い方法">
                    <Typography>{settingData.payment_method}</Typography>
                </DefinitionRow>

                <DefinitionRow label="お支払期限">
                    <Typography>{settingData.payment_deadline}</Typography>
                </DefinitionRow>

                <DefinitionRow label="連絡先電話番号">
                    <Typography>{settingData.contact_phone_number}</Typography>
                </DefinitionRow>

                <DefinitionRow label="連絡先メールアドレス">
                    <Typography>{settingData.contact_email_address}</Typography>
                </DefinitionRow>

                <DefinitionRow label="営業時間">
                    <Typography>{settingData.business_hours}</Typography>
                </DefinitionRow>
            </Paper>
        </>
    );
};

export default CompanyPage;
